/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="4"
        height="18"
        viewBox="0 0 4 18"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M2 14a2 2 0 1 1-2 2 2 2 0 0 1 2-2Zm0-7a2 2 0 1 1-2 2 2 2 0 0 1 2-2Zm0-7a2 2 0 1 1-2 2 2 2 0 0 1 2-2Z"
          className="icon-fill"
          fillRule="evenodd"/>
      </svg>
    );
  }
}

Icon.displayName = 'ThreeVerticalDotsIcon';

export default Icon;
